import withStyles from "@material-ui/core/styles/withStyles";
import { setPreview as setPreviewAction } from "Actions/commonAction";
import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import emptyImgae from "Assets/Svg/career-page.svg";

import Grid from "@material-ui/core/Grid";

const styles = () => ({
  drawerPaper: {
    width: "30%",
  },
});

class AboutUs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: { editable: true, readonly: true },
      value: 0,
      imgcount: 2,
      isImages: true,
    };
    this.handleTabChange = this.handleTabChange.bind(this);
  }

  handleChange = (event, value, id) => {
    this.setState({ value, id }, () => {});
  };

  handleTabChange(value) {
    this.setState({
      value,
    });
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    const { imgcount, isImages } = this.state;
    return (
      <Grid container spacing={3} style={{ marginBottom: 64 }}>
        <Grid item xs={12} md={8} sm={12}>
          <p className="small-dark-secondary margin-bottom-16">ABOUT US</p>
          <h6 className="section-title">What we do</h6>
          <p className="small-dark-secondary margin-bottom-16">
            It’s an audacious, incredibly rewarding mission that our
            increasingly diverse team is dedicated to achieving. Airbnb is built
            around the idea that everyone should be able to take the perfect
            trip, including where they stay, what they do, and who they meet. To
            that end, we empower millions of people around the world to use
            their spaces, passions, and talents to become entrepreneurs.
            Exciting challenges lie ahead—new regions, technologies, and
            businesses. Guided by our four core values, we’ll meet these
            challenges creatively and with the support of our global community.
            Join us!
          </p>
        </Grid>
        <Grid item xs={12} md={4} sm={12}>
          {isImages ? (
            <div className="text-center width100 position-rel">
              <img
                src={emptyImgae}
                height="200"
                width="200"
                style={{
                  position: "absolute",
                  border: "1px solid #ddd",
                  zIndex: 0,
                  background: "#fff",
                  top: 0,
                  left: 0,
                  display: "block",
                }}
              ></img>
              {imgcount == 2 ? (
                <img
                  src={emptyImgae}
                  height="200"
                  width="200"
                  style={{
                    position: "absolute",
                    border: "1px solid #ddd",
                    zIndex: 0,
                    background: "#fff",
                    top: 32,
                    left: 64,
                    display: "block",
                  }}
                ></img>
              ) : (
                <div
                  style={{
                    position: "absolute",
                    border: "4px solid #1e8ced",
                    zIndex: 1,
                    width: 200,
                    height: 200,
                    top: 32,
                    left: 64,
                  }}
                ></div>
              )}
              <img
                src={emptyImgae}
                height="200"
                width="200"
                style={{
                  border: "1px solid #ddd",
                  position: "absolute",
                  zIndex: 2,
                  background: "#fff",
                  top: 82,
                  left: 128,
                  display: "block",
                }}
              ></img>
            </div>
          ) : (
            <div style={{ height: "100%", width: "100%" }}>Video</div>
          )}
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setPreview: setPreviewAction,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(AboutUs)));
